import { gql } from '@apollo/client';

export const DELETE_COMBO = gql`
  mutation deleteCombo($id: Int!) {
    deleteCombo(id: $id) {
      id
    }
  }
`;
